import React from "react";
import { Button } from "./ui/button";
import { Sparkles } from "lucide-react";

const scrollToServices = () => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });

const CTABanner = () => {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary to-primary/80 px-6 md:px-14 py-12 md:py-16 text-center">
          <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/10" />
          <div className="absolute -bottom-12 -left-12 w-52 h-52 rounded-full bg-white/10" />
          <div className="relative">
            <span className="inline-flex items-center gap-2 bg-white/15 text-white px-4 py-1.5 rounded-full text-sm font-medium">
              <Sparkles className="w-4 h-4 text-accent" /> Your Home · Your Beauty · Your Timings
            </span>
            <h2 className="font-display text-3xl md:text-5xl font-extrabold text-white mt-5 max-w-3xl mx-auto leading-tight">
              Ready to be pampered at home?
            </h2>
            <p className="text-white/85 mt-4 max-w-xl mx-auto">
              Book professional beauticians in a few taps. Available 9 AM – 9 PM, all days across Gurugram.
            </p>
            <Button onClick={scrollToServices} className="mt-7 bg-white text-primary hover:bg-white/90 rounded-full h-12 px-9 text-base font-bold">
              Book Your Appointment
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
